import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    // Mostrar el popup solo si no ha sido visto antes
    if (!localStorage.getItem("hasSeenPopup")) {
      this.contentTarget.style.display = "block";
      localStorage.setItem("hasSeenPopup", "true");
    }
  }
}
